<!--
-->
<span 
  on:click
  class="icon-container { css && css.classes(vw) }"
  style={ css && css.styled(vw) }
  {tabindex}
  >
  <svg 
    class="icon {spin ? ' spin' : 'center'}"
    style={ icss && icss.styled(vw) }
    viewBox="0 0 24 24">
    <use 
      xlink:href={`${source}/${svgname}.svg#${prefix}${svgname}`} 
      />
  </svg>  
</span>


<style>
.icon-container {
  box-sizing: border-box;
  display: inline-block;
  text-align: center;
  padding: 0;
  margin: 0;
  fill: inherit;
  position: relative;
  no-border: 1px dotted red;

  /* fix alignment of image with text baseline /*/
  margin-bottom: -0.25em; 
}

.icon {
  box-sizing: border-box;
  display: inline-block;
  fill: inherit;
  stroke: inherit;
  color: inherit;
  background-color: transparent;
  padding: 0;
  margin: 0;
  line-height: 1em;
}

/**
 *  Fix vertical centering of icon inside container 
 */
.icon.center {
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}

/** 
 *  Make an existing SVG to spin (loading icon)
 *  https://stackoverflow.com/questions/40256473/make-an-existing-svg-to-spin-loading-icon
 */
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% {  transform: rotate(359deg); }
}
.icon.spin {
  animation: spin 2s linear infinite;
}

</style>

<svelte:window bind:innerWidth={vw} />

<script>
  import { fade } from 'svelte/transition'
  import { Theme, Css } from '../theme';

  export let 
    name = '',
    size = null, // rem or px or whatever ...
    spin = null,
    show = true,
    tabindex = undefined;

  let 
    theme = Theme.active(),
    source = theme.icons.source,
    prefix = theme.icons.prefix,
    svgname = theme.icons.files[name] || '',
    vw = 0;

  // the icon-container css props
  let css, icss;

  $: if (vw && $$props) {
    // the icon-container css props
    css = Css($$props)
              .blacklist(['font-size','color']);
    
    // the icon css props
    icss = Css($$props)
                .synonym('size', 'font-size')
                .synonym('color', 'fill')
                .shorthand(['xs','sm','nm','md','lg','xl','h2','h1'], 'font-size')
                .whitelist(['font-size','fill'])
                
    // set default props if none defined
    icss.set('font-size', icss.get('font-size') || '1rem');
    
    // adjust icon-container props based on other received props
    css.set('height', css.get('height') || icss.get('font-size'))
        .set('width', css.get('width') || css.get('height') || icss.get('font-size'))
        .set('line-height', css.get('height') || icss.get('font-size'))
                
    // adjust icon props based on other received props
    // height is needed by SVG to correctly scale the icon
    icss.set('height', icss.get('font-size'));

    show = css.visible(show, vw);
    // console.log("$ Icon vw=", vw, show)
  }

  $: if ($$props['name']) {
    svgname = theme.icons.files[name] || '';
  }
</script>
